import { WizardStep } from '../constant';
import type {
  IStepFieldConfigState,
  IStepSelectTablesState,
  IStepYamlDraftState,
} from '../types';
import { buildEmptyCustomRowEdit } from './fieldConfigRowUtils';
import type { IAgentCreateWizardSnapshot } from './agentCreateCacheManager';

export function createInitialSelectTablesState(): IStepSelectTablesState {
  return {
    databaseValue: '',
    dataBaseData: [],
    dataBaseOptions: [],
    dataBaseLoading: false,
    dataBaseError: false,
    schemaValue: '',
    schemaOptions: [],
    tablesLoading: false,
    tablesError: false,
    tablesValue: [],
    tablesName: '',
    tablesOptions: [],
  };
}

export function createInitialFieldConfigState(): IStepFieldConfigState {
  return {
    fieldsValue: [],
    fieldColumns: [],
    fieldLoading: false,
    fieldError: false,
    dimInlineOpen: false,
    measInlineOpen: false,
    dimAddDraft: buildEmptyCustomRowEdit('dimension'),
    measAddDraft: buildEmptyCustomRowEdit('metric'),
  };
}

export function createInitialYamlDraftState(): IStepYamlDraftState {
  return {
    cube_name: '',
    yamlReady: false,
    yamlText: '',
    yamlLoading: false,
    yamlError: false,
    savedConfigUuid: '',
  };
}

interface IToWizardPersistSnapshotInput {
  current: WizardStep;
  selectTables: IStepSelectTablesState;
  fieldConfig: IStepFieldConfigState;
  yamlDraft: IStepYamlDraftState;
  fieldConfigLoadKey: string;
}

/**
 * 从运行时 state 打出快照：与 restore 成对，整包字段一致；
 * 仅剔除 dataBaseOptions（含 React 节点）并在落盘前关闭 loading。
 */
export function toWizardPersistSnapshot(
  input: IToWizardPersistSnapshotInput,
): IAgentCreateWizardSnapshot {
  const { selectTables, fieldConfig, yamlDraft, ...rest } = input;
  return {
    ...rest,
    selectTables: {
      ...selectTables,
      dataBaseOptions: [],
      dataBaseLoading: false,
      tablesLoading: false,
    },
    fieldConfig: {
      ...fieldConfig,
      fieldLoading: false,
    },
    yamlDraft: {
      ...yamlDraft,
      yamlLoading: false,
      savedConfigUuid: '',
    },
  };
}

/** 将快照还原为可 set 的 state；不与 prev 合并，避免残留字段 */
export function fromWizardPersistSnapshot(
  snapshot: IAgentCreateWizardSnapshot,
): IToWizardPersistSnapshotInput {
  return {
    current: snapshot.current,
    selectTables: {
      ...snapshot.selectTables,
      dataBaseOptions: [],
    },
    fieldConfig: snapshot.fieldConfig,
    yamlDraft: snapshot.yamlDraft,
    fieldConfigLoadKey: snapshot.fieldConfigLoadKey,
  };
}
